import { motion } from 'framer-motion';
import { useState } from 'react';

const Blank = ({ theme = 'dark' }) => {
    const isDarkMode = theme === 'dark';

    const pageStyles = {
        minHeight: '100vh',
        padding: '1rem 0',
        fontSize: '14px',
        color: isDarkMode ? '#e5e7eb' : '#2c3e50',
        transition: 'background 0.25s ease, color 0.25s ease'
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="coupon-page-container"
            style={pageStyles}
        >
            <div className="container-fluid px-3">
                this is blank page
            </div>
        </motion.div>
    );
};

export default Blank;
